
import React from 'react'
import {connect} from 'react-redux'
import Document from './Document'
import Spinner from './Spinner'
import {
  fetchFloorPicker,
  fetchMapDocument,
  fetchUnits,
  receiveAndApplyFilterChange
} from '../actions'

class App extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      width: window.innerWidth,
      height: window.innerHeight
    }

    const {
        config
    } = this.props

    if (config.layout === 'highrise') {
      this.props.dispatch(fetchFloorPicker(config.highrise.floorpicker.unitmap.path))
    }
    this.props.dispatch(fetchMapDocument(config.unitmap.path))
    this.props.dispatch(fetchUnits(config.unitsUrl))

    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.handleResize = this.handleResize.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.document !== this.props.document
      || nextState.width !== this.state.width
      || nextState.height !== this.state.height
      || nextProps.filteredUnits !== this.props.filteredUnits
      || nextProps.filters !== this.props.filters
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleFilterChange(event) {
    this.props.dispatch(receiveAndApplyFilterChange(event.valueFor, event.value))
  }

  handleResize(event) {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    })
  }

  render() {
    const {
      config,
      document,
      filteredUnits,
      floorPicker
    } = this.props

    const {
      height,
      width
    } = this.state

    return (document && filteredUnits && (floorPicker || config.layout !== 'highrise'))
      ? <Document {...this.props} width={width} height={height} onChange={this.handleFilterChange} onFilterReset={this.handleFilterReset} />
      : <Spinner />
  }
}

// Which props do we want to inject, given the global state?
// Note: use https://github.com/faassen/reselect for better performance.
function mapStateToProps(state) {
  return state.toObject()
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(App)
// export default App
